__turbopack_context__.v({
  "card": "CartSummaryCard-module__2s9KCG__card",
  "content": "CartSummaryCard-module__2s9KCG__content",
  "divider": "CartSummaryCard-module__2s9KCG__divider",
  "offer-divider": "CartSummaryCard-module__2s9KCG__offer-divider",
  "offer-icon": "CartSummaryCard-module__2s9KCG__offer-icon",
  "offer-item": "CartSummaryCard-module__2s9KCG__offer-item",
  "paymentOffers": "CartSummaryCard-module__2s9KCG__paymentOffers",
  "taxInfo": "CartSummaryCard-module__2s9KCG__taxInfo",
  "totalRow": "CartSummaryCard-module__2s9KCG__totalRow",
});
